module.exports = __webpack_public_path__ + "img/2.6a987ef5.png";